export default __webpack_public_path__ + "static/media/thumb3.28287f9b.png";